<template>
    <div class="ai-assistant-panel">
      <div class="avatar">
        <img
          :class="{ listening: isListening, thinking: isThinking }"
          src="@/assets/AIANALYST450px.png"
          alt="AI Avatar"
        />
      </div>
      <h3>Anaylze Artist Tours</h3>
      <!-- <p class="ai-question">🤖 I can help you find the best tour dates for your favorite artists!</p>
        <p class="ai-question">🤖 Just say or type the artist name and I will do the rest!</p>
        <p class="ai-question">🤖 I will also show you the best venues and cities to visit!</p> -->
<!-- 👇 ADD v-if="showSteps" -->
<div class="chat-log" v-if="showSteps">
  <p v-for="(step, i) in steps" :key="i" :class="{ active: !step.done }">
    <span v-if="step.done">✅</span>
    <span v-else>⏳</span> {{ step.label }}
  </p>
</div>

  
      <!-- <div v-if="currentStep === 0" class="interaction">
  <p class="ai-question">🎤 What artist do you want to research?</p>

  <input
    v-model="artistInput"
    placeholder="Say or type artist name..."
    @input="fetchArtistSuggestions"
    @keyup.enter="submitArtist"
  />

  <ul v-if="artistSuggestions.length" class="suggestion-list">
    <li
      v-for="artist in artistSuggestions"
      :key="artist.id"
      @click="selectArtist(artist)"
    >
      {{ artist.name }}
    </li>
  </ul>

  <div class="button-row">
    <button @click="startListening">
      {{ isListening ? "Listening..." : "🎙 Voice Input" }}
    </button>
    <button @click="submitArtist">Submit</button>
  </div>
</div> -->
<div v-if="currentStep === 0" class="interaction">
  <p class="ai-question">🎤 What artist do you want to research?</p>

  <input
    v-model="artistInput"
    placeholder="Say or type artist name..."
    @input="fetchArtistSuggestions"
    @keyup.enter="submitArtist"
  />

  <ul v-if="artistSuggestions.length" class="suggestion-list">
    <li
      v-for="artist in artistSuggestions"
      :key="artist.id"
      @click="selectArtist(artist)"
    >
      {{ artist.name }}
    </li>
  </ul>

  <div class="button-row">
    <button @click="startListening">
      {{ isListening ? "Listening..." : "🎙 Voice Input" }}
    </button>
    <button @click="submitArtist">Search</button>
  </div>
</div>

    </div>
  </template>
  
  <script>
import axios from "axios";

  export default {
   data() {
  return {
    artistInput: "",
    currentStep: 0,
    isListening: false,
    isThinking: false,
    recognition: null,
    artistSuggestions: [],
    spotifyToken: "",
    showSteps: false, // <-- NEW
    steps: [
      { label: "Artist received", done: false },
      { label: "Fetching Spotify artist data", done: false },
      { label: "Loading Ticketmaster/Setlist.fm/Bandsintown", done: false },
      { label: "Running AI tour prediction", done: false },
      { label: "Finalizing results and map", done: false }
    ]
  };
},

    mounted() {
  const params = new URLSearchParams(window.location.search);
  const artistFromURL = params.get("artistInput");
  const steps = params.get("steps");

  if (artistFromURL) {
    this.artistInput = decodeURIComponent(artistFromURL);
    this.submitArtist();
  }

  if (steps) {
    this.selectedSteps = steps.split(",");
  }

  this.$emit("register-assistant-ref", this);

  },
    watch: {
      artistInput() {
        this.fetchArtistSuggestions();
      }
    },
    methods: {
        async getSpotifyToken() {
  try {
    const response = await axios.post(
      "https://accounts.spotify.com/api/token",
      new URLSearchParams({
        grant_type: "client_credentials",
        client_id: "1522ec4d96914840aef42817fe1b387b",
        client_secret: "673c7686457a438488401835249dca6b",
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return response.data.access_token;
  } catch (error) {
    console.error("Error fetching Spotify access token:", error);
  }
},
    // async fetchSpotifyToken() {
    //     if (!this.spotifyToken) {
    //     this.spotifyToken = await this.getSpotifyToken();
    //     }
    // },

    async fetchArtistSuggestions() {
  if (!this.artistInput) return;
  if (!this.spotifyToken) this.spotifyToken = await this.getSpotifyToken();

  try {
    const response = await axios.get(
      `https://api.spotify.com/v1/search?q=${encodeURIComponent(this.artistInput)}&type=artist&limit=5`,
      {
        headers: {
          Authorization: `Bearer ${this.spotifyToken}`,
        },
      }
    );
    this.artistSuggestions = response.data.artists?.items || [];
  } catch (error) {
    console.error("Error fetching suggestions:", error);
  }
},


  selectArtist(artist) {
    this.artistInput = artist.name;
    this.artistSuggestions = [];
    this.submitArtist();
  },
submitArtist() {
  if (!this.artistInput) return;

  this.showSteps = true; // 👈 ENABLE the chat-log
  this.steps.forEach(s => s.done = false); // reset steps
  this.steps[0].done = true;
  this.isThinking = true;

  const msg = new SpeechSynthesisUtterance(`Searching for artist ${this.artistInput}`);
  msg.lang = "en-US";
  speechSynthesis.speak(msg);

  this.$emit("artist-submitted", this.artistInput);
  this.runSteps();
},


    //   submitArtist() {
    //     if (!this.artistInput) return;
    //     this.steps[0].done = true;
    //     this.isThinking = true;
    //     this.$emit("artist-submitted", this.artistInput);
    //     this.runSteps();
    //   },
      runSteps() {
        let delay = 1500;
        this.steps.forEach((step, index) => {
          setTimeout(() => {
            this.steps[index].done = true;
            this.currentStep++;
            if (index === this.steps.length - 1) {
              this.isThinking = false;
            }
          }, delay * (index + 1));
        });
      },
      startListening() {
        if (!("webkitSpeechRecognition" in window)) {
          alert("Speech recognition not supported in this browser.");
          return;
        }
  
        if (!this.recognition) {
          const SpeechRecognition = window.webkitSpeechRecognition;
          this.recognition = new SpeechRecognition();
          this.recognition.lang = "en-US";
          this.recognition.interimResults = false;
          this.recognition.maxAlternatives = 1;
  
          this.recognition.onstart = () => {
            this.isListening = true;
          };
  
          this.recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript.trim();
            this.artistInput = transcript;
            this.isListening = false;
            this.submitArtist();
          };
  
          this.recognition.onerror = (event) => {
            console.error("Speech recognition error", event);
            this.isListening = false;
          };
  
          this.recognition.onend = () => {
            this.isListening = false;
          };
        }
  
        this.recognition.start();
      }
    }
  };
  </script>
  
  <style scoped>
  .suggestion-list {
  list-style: none;
  padding: 0;
  margin-top: 5px;
  background: #002;
  border: 1px solid #00ffcc;
  border-radius: 10px;
  max-height: 150px;
  overflow-y: auto;
}
.suggestion-list li {
  padding: 10px;
  cursor: pointer;
}
.suggestion-list li:hover {
  background: #003;
}

  .ai-assistant-panel {
    background: rgba(10, 10, 30, 0.566);
    color: #00ffcc;
    padding: 10px 10px 10px 10px;
    border: 2px solid #00ffcc;
    border-radius: 20px;
    width: 100%;
    height: 100%;      
    max-width: 1800px;
    margin: auto;
    box-shadow: 0 0 20px #00ffcc55;
    font-family: 'Courier New', monospace;
  }
  .avatar {
    text-align: center;
    margin-bottom: 15px;
  }
  .avatar img {
    width: 140px;
    transition: transform 0.4s ease, filter 0.3s ease;
    border-radius: 100px;
  }
  .avatar img.listening {
    filter: hue-rotate(180deg) brightness(1.3);
    animation: pulse 1.5s infinite;
  }
  .avatar img.thinking {
    animation: spin 2s linear infinite;
  }
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.07);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .chat-log {
    margin-bottom: 20px;
    background: #001;
    padding: 10px;
    border-radius: 10px;
  }
  .chat-log p {
    margin: 5px 0;
  }
  .ai-question {
    font-size: 18px;
    margin-bottom: 10px;
  }
  input {
    width: 100%;
    padding: 10px;
    background: black;
    color: white;
    border: 1px solid #00ffcc;
    border-radius: 10px;
  }
  .button-row {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  button {
    flex: 1;
    margin: 5px;
    background: #00ffcc;
    border: none;
    padding: 10px;
    border-radius: 8px;
    font-weight: bold;
    color: black;
    cursor: pointer;
  }
  button:hover {
    background: #00f0aa;
  }
  </style>
  